import {
    Image,
    TouchableOpacity,
    View
} from "react-native";
import {
    type AnnouncementCardProps,
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    useDebouncedDimensions
} from "../../../../../utils";
import Linear from "../../../../../assets/images/linear.png";

const AnnouncementsCard = ({
    coverPhotoURL,
    description,
    onPress,
    title
}: AnnouncementCardProps) => {
    const {
        windowWidth
    } = useDebouncedDimensions();

    const {
        radiuses,
        spaces
    } = NCoreUIKitTheme.useContext();

    return <TouchableOpacity
        onPress={onPress}
        style={[
            stylesheet.container,
            {
                width: windowWidth - spaces.spacingMd * 2,
                height: (windowWidth - spaces.spacingMd * 2) * 1.25,
                borderRadius: radiuses.xl,
                marginBottom: spaces.spacingMd
            }
        ]}
    >
        <Image
            source={{
                uri: coverPhotoURL
            }}
            style={[
                stylesheet.image,
                {
                    borderRadius: radiuses.xl
                }
            ]}
        />
        <Image
            source={Linear}
            style={[
                stylesheet.linear,
                {
                    borderRadius: radiuses.xl
                }
            ]}
        />
        <View
            style={[
                stylesheet.content,
                {
                    paddingHorizontal: spaces.spacingXl,
                    paddingBottom: spaces.spacingMd
                }
            ]}
        >
            <Text
                color="onPrimary"
                variant="headlineSmallSize"
                style={{
                    marginTop: spaces.spacingSm
                }}
            >
                {title}
            </Text>
            <Text
                color="onPrimary"
                variant="bodyLargeSize"
                style={{
                    marginTop: spaces.spacingSm
                }}
            >
                {description.length > 50
                    ? `${description.substring(0, 100)}..`
                    : description}
            </Text>
        </View>
    </TouchableOpacity>;
};
export default AnnouncementsCard;
